import * as React from 'react';

import { Close as IconClose } from '@mui/icons-material';
import { IconButton, Alert } from '@mui/material';

import { getRandomInt } from '@x_x_x/utils';

import { IAlert, IAlertOptions } from '@interfaces';

import { IAlertsContext, IAlertsProps, IAlertState } from './types';

import s from './Alerts.scss';

const DEFAULT_TIMEOUT = 5000;

export const AlertsContext = React.createContext<IAlertsContext>({});

export const useAlertsContext = () => React.useContext(AlertsContext);

class Alerts extends React.PureComponent<React.PropsWithChildren<IAlertsProps>, IAlertState> {

	state: IAlertState = {
		alerts: [],
	};

	providedValue: IAlertsContext;

	constructor(props: IAlertsProps) {
		super(props);

		this.providedValue = { showAlert: this.showAlert, hideAllAlerts: this.hideAllAlerts };
	}

	showAlert = (options: IAlertOptions) => {
		const id = getRandomInt();
		const { isPermanent, timeout = DEFAULT_TIMEOUT } = options;

		this.setState({
			alerts: this.state.alerts.concat({
				...options,
				id,
			}),
		});

		if (!isPermanent) {
			setTimeout(() => this.hideAlert(id), timeout);
		}
	};

	hideAlert(id: number) {
		this.setState({
			alerts: this.state.alerts.filter((alert) => alert.id !== id),
		});
	}

	hideAllAlerts = () => {
		this.setState({ alerts: [] });
	};

	onCloseAlertClick = (alert: IAlert) => {
		this.hideAlert(alert.id);
	};

	render() {
		return (
			<AlertsContext.Provider value={this.providedValue}>
				{this.props.children}

				{this.state.alerts.length > 0 && (
					<div className={s.root}>
						{this.state.alerts.map((alert, index) => (
							<Alert
								key={index}
								severity={alert.type}
								action={
									<IconButton
										aria-label="close"
										color="inherit"
										size="small"
										onClick={() => this.onCloseAlertClick(alert)}
									>
										<IconClose fontSize="inherit" />
									</IconButton>
								}
								sx={{ mb: 2 }}
							>
								{alert.text}
							</Alert>
						))}
					</div>
				)}
			</AlertsContext.Provider>
		);
	}

}

export const AlertsProvider = Alerts;
